import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import moment from "moment";
// import ListGroup from "./common/listGroup";

const GrabberChart = ({ data, codes, handleHideChart }) => {
  const [series, setSeries] = useState([]);
  const [type] = useState({ id: "line" });

  const options = {
    chart: { id: "data" },
    colors: ["#2ecc71", "#3498db", "#f1c40f", "#e74c3c", "#9b59b6"],
    stroke: {
      curve: "straight"
    },
    tooltip: { shared: true, theme: "dark", x: { show: false } },
    yaxis: {
      forceNiceScale: true,
      decimalsInFloat: 3
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      type: "datetime",
      tooltip: { formatter: d => moment(d).format("Do MMM ha") }
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      }
    }
  };

  // const chartTypes = [
  //   { id: "line", name: "Line" },
  //   { id: "scatter", name: "Scatter" }
  // ];

  useEffect(() => {
    if (data.length === 0) return;
    if (codes.length === 0) return;
    const series = [];
    codes.map(code => {
      const codeSeries = { name: code.code, data: [] };
      data.map(d => {
        if (d[code.code])
          return codeSeries.data.push({ x: d.REAL_DATETIME, y: d[code.code] });
        return null;
      });
      return series.push(codeSeries);
    });
    setSeries(series);
  }, [data, codes]);

  function handleHide() {
    setSeries([]);
    handleHideChart();
  }

  return (
    <div>
      {codes.length === 0 ? null : (
        <React.Fragment>
          <div className="row">
            <div className="col-auto">
              <button className="btn btn-primary mt-4" onClick={handleHide}>
                Hide Chart
              </button>
            </div>
            <div className="col-auto">
              {/* <ListGroup
                items={chartTypes}
                onItemSelect={t => setType(t)}
                selectedItem={type}
              /> */}
            </div>
          </div>
          <Chart
            options={options}
            series={series}
            type={type.id}
            height={400}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default GrabberChart;

// const [options, setOptions] = useState({
//   chart: { id: "data" },
//   colors: ["#2ecc71", "#3498db", "#f1c40f", "#e74c3c", "#9b59b6"],
//   stroke: {
//     curve: "straight"
//   },
//   tooltip: { shared: true },
//   yaxis: {
//     forceNiceScale: true,
//     decimalsInFloat: 3
//   },
//   dataLabels: {
//     enabled: false
//   },
//   xaxis: {
//     type: "datetime"
//   },
//   grid: {
//     show: true,
//     xaxis: {
//       lines: {
//         show: true
//       }
//     },
//     yaxis: {
//       lines: {
//         show: true
//       }
//     }
//   }
// });
